<template>
  <v-layout wrap ma-0>
    <v-flex class="strip-btn">
      <nuxt-link to="/smartalerts.aspx" class="d-block text-center no-underline">
        <span class="text-center display-24 "><slot /></span>
      </nuxt-link>
    </v-flex>
  </v-layout>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.strip-btn {
  padding:0 0 10px ;
  background-color: #3e4a54;

  }
a{
  color:#fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
.strip-btn a span:after {
    content: '\203a';
    white-space: nowrap;
    font-size: 60px;
    display: inline-block;
    text-align: center;
    margin-right: 15px;
    line-height: 60px;
    vertical-align: sub;
}
@media screen and (max-width: 600px) {
  .strip-btn a span:after {
    font-size: 35px;
  }
}
</style>
